export default "__VITE_ASSET__CN6Dk0wG__"